module.exports = __webpack_public_path__ + "public/SiteIcons/map-pin-small.png?0b98dcc4";